import React, { useEffect, useState } from "react";
import {
    Typography,
    Paper,
    Button,
    Divider,
    List,
    makeStyles,
} from "@material-ui/core";

import MainScreen from "./templates/MainScreen";
import { useTranslation } from "react-i18next";
import Person from "../components/Person";
import api from "../../utils/api";
import routes from "../../utils/apiRoutes.json";

const useStyles = makeStyles((theme) => ({
    fullWidth: {
        width: "100%",
    },
    maxWidth: {
        maxWidth: "500px",
    },
    blackElem: {
        backgroundColor: theme.palette.primary.main,
    },
    playButton: {
        backgroundColor: theme.palette.primary.main,
        width: "100%",
        "&:hover": {
            background: theme.palette.primary.main,
        },
        marginTop: "10px",
        marginBottom: "10px",
        paddingTop: "20px",
        paddingBottom: "20px",
    },
    inviteButton: {
        backgroundColor: theme.palette.primary.main,
        width: "100%",
        "&:hover": {
            background: theme.palette.primary.main,
        },
        marginTop: "10px",
        marginBottom: "10px",
    },
    userAvatar: {
        marginTop: "auto",
        marginBottom: "auto",
        marginRight: "20px",
    },
    icon: {
        marginTop: "auto",
        marginBottom: "auto",
        marginLeft: "auto",
    },
    marginButton: {
        margin: "20px 7%",
    },
    flex: {
        display: "flex",
        flexDirection: "row",
    },
}));

export default function TournamentGames(): JSX.Element {
    const { t } = useTranslation();
    const classes = useStyles();

    const [friends, setState] = useState([])

    useEffect(() => {
        api.get(
            routes.friendsList,
        )
            .then(response => {
                console.log(response.data.data.FRIENDS);
                        
                setState(response.data.data.FRIENDS)
            });
                //console.log(response);
                //setState(response);
            }, []);
            
    const playerElements = friends.map((item: any, i) => <Person key={i} id={item.id} personName={item.username} path={"#"} />);

    return (
        <MainScreen lower={false} back={true}>
            <Paper style={{ overflow: "auto" }} elevation={0}>
                <Button color="primary" classes={{ root: classes.playButton }}>
                    <Typography variant="h4" color="secondary">
                        {t("tournament-creator.play")}
                    </Typography>
                </Button>
                <Button color="primary" classes={{ root: classes.inviteButton }}>
                    <Typography variant="h6" color="secondary">
                        {t("tournament-creator.invite")}
                    </Typography>
                </Button>
                <Typography variant="h6">
                    {t("tournament-creator.players", { number: playerElements.length })}
                </Typography>
                <Divider orientation="horizontal" classes={{ root: classes.blackElem }} />
                <List>
                    {playerElements}
                </List>
            </Paper>
        </MainScreen>
    );
}
